import React, { Fragment, useEffect, useState, useMemo, useCallback, Component, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetBranchState, getBranch as onGetBranches, addNewBranch as onAddNewBranch, updateBranch as onUpdateBranch, deleteBranch as onDeleteBranch, getBranchLoading, getBranch } from "../../../store/branch/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import ModalImage from "react-modal-image";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Branch = (props) => {
  const { t } = props;
  const [placeValue, setPlaceValue] = useState("");
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [mediaType, setMediaType] = useState("");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, branches, isBranchCreated, isBranchSuccess, loading, error, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    branches: state.Branch.branches,
    isBranchCreated: state.Branch.isBranchCreated,
    isBranchSuccess: state.Branch.isBranchSuccess,
    loading: state.Branch.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Branch.error,
  }));

  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [info, setInfo] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const statusVisibilityData = [
    {
      options: [
        { label: "Visible", value: "Visible" },
        { label: "Hidden", value: "Hidden" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [assetFiles, setAssetFiles] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (branch) => {
    setBranch(branch);
    setDeleteModal(true);
  };

  const handleDeleteBranch = () => {
    if (branch) {
      dispatch(onDeleteBranch(branch));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredBranches = branches;
      if (type !== "all") {
        filteredBranches = branches.filter((branch) => branch.branch_status.name === type);
      }
      setBranchList(filteredBranches);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetBranchState());
      dispatch(onGetBranches({ svg: true, companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      let filteredBranches = branches;
      if (activeTypeTab !== "all") {
        filteredBranches = branches.filter((branch) => branch.branch_status.name === activeTypeTab);
      }
      setBranchList(filteredBranches.map((el) => ({ ...el, isChecked: false })));
      setIsEdit(false);
      const data = branches[branches.length - 1];
      setInfo(data);
      if (data.latitude && data.latitude) setLocationCord([data.latitude, data.longitude]);
    }
  }, [branches]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "branch_code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "branch_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (branchList.length > 0) {
      branchList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "branch_company") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [branchList]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [{ label: null, value: null }];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);

      if (opt.length > 0) {
        setParentList(data);
      } else {
        setParentList([]);
      }
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setBranch(null);
      setPlaceValue("");
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleBranchClick = useCallback(
    (arg) => {
      const data = arg;
      let address_branch = {};
      for (const address of data.branch_address) {
        if (address.isPrimary) {
          address_branch = address;
        }
      }

      setPlaceValue(
        data.branch_address.length > 0
          ? {
              label: `${address_branch.village} ${address_branch.district} ${address_branch.city} ${address_branch.province} ${address_branch.country}`,
              value: `${address_branch.village} ${address_branch.district} ${address_branch.city} ${address_branch.province} ${address_branch.country}`,
            }
          : ""
      );

      let files = [];
      for (const f of data.branch_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setAssetFiles(files);

      setBranch({
        id: data.id,
        name: data.name,
        branch_code: data.branch_code,
        sbum: data.sbum,
        file: data.branch_file,
        isWarehouse: data.isWarehouse,
        isSellingOffline: data.isSellingOffline,
        isSellingOnline: data.isSellingOnline,
        attendance_distance: data.attendance_distance,
        sinceat: data.sinceat,
        description: data.description,
        latitude: data.latitude,
        longitude: data.longitude,
        visibility: data.visibility && {
          label: data.visibility,
          value: data.visibility,
        },
        company: {
          label: data.branch_company ? data.branch_company.name : "",
          value: data.branch_company ? data.branch_company.id : "",
        },
        client: {
          label: data.branch_client ? data.branch_client.name : "",
          value: data.branch_client ? data.branch_client.id : "",
        },
        parent: data.branch_parent && {
          label: data.branch_parent ? data.branch_parent.name : "",
          value: data.branch_parent ? data.branch_parent.id : "",
        },
        status: data.branch_status && {
          label: data.branch_status.name,
          value: data.branch_status.id,
        },
        zip: address_branch.code ?? "",
        address:
          data.branch_address.length < 1
            ? ""
            : {
                label: `${address_branch.village} ${address_branch.district} ${address_branch.city} ${address_branch.province} ${address_branch.country}`,
                value: {
                  description: `${address_branch.village} ${address_branch.district} ${address_branch.city} ${address_branch.province} ${address_branch.country}`,
                  matched_substrings: [],
                  place_id: "",
                  reference: "",
                  structured_formatting: {},
                  terms: [],
                  types: [],
                },
              },
        svg_siteplan: data.svg_siteplan,
        svg_siteplan_project: data.svg_siteplan_project,
        svg_rincik: data.svg_rincik,
        street: address_branch.description ?? "",
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteBranch(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = branchList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setBranchList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = branchList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setBranchList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      setLocationCord([data.latitude, data.longitude]);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateBranch") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleBranchClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteBranch") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: `${t("Nama")}`,
        accessor: "name",
        filterable: true,
      },
      {
        Header: `${t("Kode")}`,
        accessor: "branch_code",
        filterable: true,
      },
      // {
      //   Header: `${t("Branch")} ${t("Parent")}`,
      //   accessor: "branch_parent.name",
      //   filterable: true,
      // },
      {
        Header: `${t("Perusahaan")}`,
        accessor: "branch_company.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "unit_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [branchList, handleBranchClick, userType, userRole, t, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = branchList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setBranchList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => branchList, [branchList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (branch && branch.client) || clientSelected,
      company: (branch && branch.company) || companySelected,
      name: (branch && branch.name) ?? "",
      attendance_distance: (branch && branch.attendance_distance) ?? "",
      branch_code: (branch && branch.branch_code) ?? "",
      sbum: (branch && branch.sbum) || 0,
      longitude: (branch && branch.longitude) ?? "",
      latitude: (branch && branch.latitude) ?? "",
      status: (branch && branch.status) ?? "",
      description: (branch && branch.description) ?? "",
      visibility: (branch && branch.visibility) ?? "",
      isWarehouse: (branch && branch.isWarehouse) || false,
      isSellingOffline: (branch && branch.isSellingOffline) || false,
      isSellingOnline: (branch && branch.isSellingOnline) || false,
      parent: (branch && branch.parent) || false,
      zip: (branch && branch.zip) ?? "",
      address: (branch && branch.address) ?? "",
      street: (branch && branch.street) ?? "",
      svg_siteplan: (branch && branch.svg_siteplan) ?? "",
      svg_siteplan_project: (branch && branch.svg_siteplan_project) ?? "",
      svg_rincik: (branch && branch.svg_rincik) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Branch Name"),
      branch_code: Yup.string().required("Please Enter Branch Kode"),
      sbum: Yup.string().required("Please Enter SBUM"),
      company: Yup.object().required("Please Select Company"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      status: Yup.object().required("Please Select Status"),
    }),
    onSubmit: (values) => {
      dispatch(getBranchLoading());
      if (isEdit) {
        let editDataSubmit = {};

        if (values.address.value && values.address.value.terms.length > 0) {
          editDataSubmit = {
            id: branch.id,
            name: values.name,
            branch_code: values.branch_code,
            sbum: values.sbum,
            longitude: values.longitude,
            latitude: values.latitude,
            statusId: values.status.value,
            description: values.description,
            parentId: values.parent ? values.parent.value : null,
            companyId: values.company.value,
            isWarehouse: values.isWarehouse,
            isSellingOffline: values.isSellingOffline,
            isSellingOnline: values.isSellingOnline,
            attendance_distance: values.attendance_distance,
            clientId: values.client.value,
            zip: values.zip,
            street: values.street,
            visibility: values.visibility && values.visibility.value,
            svg_siteplan: values.svg_siteplan,
            svg_siteplan_project: values.svg_siteplan_project,
            svg_rincik: values.svg_rincik,
            files: assetFiles.length > 0 ? assetFiles : [],
          };

          if (values.address.value) {
            editDataSubmit = {
              ...editDataSubmit,
              village: values.address.value.terms[0].value,
              district: values.address.value.terms[values.address.value.terms.length - 4].value,
              city: values.address.value.terms[values.address.value.terms.length - 3].value,
              province: values.address.value.terms[values.address.value.terms.length - 2].value,
              country: values.address.value.terms[values.address.value.terms.length - 1].value,
            };
          }
        } else {
          editDataSubmit = {
            id: branch.id,
            name: values.name,
            branch_code: values.branch_code,
            sbum: values.sbum,
            longitude: values.longitude,
            latitude: values.latitude,
            statusId: values.status.value,
            description: values.description,
            parentId: values.parent ? values.parent.value : null,
            companyId: values.company.value,
            isWarehouse: values.isWarehouse,
            isSellingOffline: values.isSellingOffline,
            isSellingOnline: values.isSellingOnline,
            attendance_distance: values.attendance_distance,
            clientId: values.client.value,
            zip: values.zip,
            street: values.street,
            visibility: values.visibility && values.visibility.value,
            svg_siteplan: values.svg_siteplan,
            svg_siteplan_project: values.svg_siteplan_project,
            svg_rincik: values.svg_rincik,
            files: assetFiles.length > 0 ? assetFiles : [],
          };

          if (values.address.value) {
            editDataSubmit = {
              ...editDataSubmit,
              village: branch.village,
              district: branch.district,
              city: branch.city,
              province: branch.province,
              country: branch.country,
            };
          }
        }

        dispatch(onUpdateBranch(editDataSubmit));
        validation.resetForm();
      } else {
        let newBranch = {
          name: values.name,
          branch_code: values.branch_code,
          sbum: values.sbum,
          longitude: values.longitude,
          latitude: values.latitude,
          statusId: values.status.value,
          description: values.description,
          parentId: values.parent ? values.parent.value : null,
          companyId: values.company.value,
          isWarehouse: values.isWarehouse,
          isSellingOffline: values.isSellingOffline,
          isSellingOnline: values.isSellingOnline,
          attendance_distance: values.attendance_distance,
          clientId: values.client.value,
          zip: values.zip,
          street: values.street,
          visibility: values.visibility && values.visibility.value,
          svg_siteplan: values.svg_siteplan,
          svg_siteplan_project: values.svg_siteplan_project,
          svg_rincik: values.svg_rincik,
          files: assetFiles.length > 0 ? assetFiles : [],
        };

        if (values.address.value) {
          newBranch = {
            ...newBranch,
            village: values.address.value.terms[0].value,
            district: values.address.value.terms[values.address.value.terms.length - 4].value,
            city: values.address.value.terms[values.address.value.terms.length - 3].value,
            province: values.address.value.terms[values.address.value.terms.length - 2].value,
            country: values.address.value.terms[values.address.value.terms.length - 1].value,
          };
        }

        dispatch(onAddNewBranch(newBranch));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetBranches(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setBranchList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetBranchState());
    dispatch(onGetBranches({ svg: true, companyId: companySelected?.value ?? "" }));
  };

  document.title = `${t("Cabang")} | Enterprise Resources Planning`;
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={branchList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBranch} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title={t("Organisasi")} pageTitle={t("Cabang")} loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createBranch") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setBranch("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-hotel-line me-1 align-bottom fs-14"></i>
              {t("Tambah")}
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "executive" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteBranch") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>
              {t("Hapus")}
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={7}>
            <Card id="branchList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-hotel-line me-1 align-bottom fs-14"></i>SEMUA CABANG
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggle();
                      validation.resetForm();
                      validation.setErrors({});
                      setCompanyList([]);
                    }}
                  >
                    {!!isEdit ? `${t("Ubah")} ${t("Cabang")}` : `${t("Tambah")} ${t("Cabang")}`}
                  </ModalHeader>
                  <ModalBody>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              // setCompanyList([]);
                              validation.setFieldValue("client", e);
                              // handleGetCompany(e.value);
                            }}
                            options={clientList}
                          ></Select>
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              validation.setFieldValue("parent", "");
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                              // dispatch(resetBranchState());
                              // dispatch(onGetBranches({ companyId: e.value }));
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="parent" className="form-label">
                            Proyek / Cabang Induk
                          </Label>
                          <Select
                            name="parent"
                            value={validation.values.parent}
                            placeholder="Pilih Proyek / Cabang"
                            onChange={(e) => {
                              dispatch(setBranchSelect(e));
                              validation.setFieldValue("parent", e);
                            }}
                            options={parentList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="branchname-field" className="form-label">
                            {t("Nama")}
                          </Label>
                          <Input name="name" id="branchname-field" className="form-control" placeholder="Isi Nama Cabang/Proyek" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="branchcode-field" className="form-label">
                            {t("Kode")}
                          </Label>
                          <Input name="branch_code" id="branchcode-field" className="form-control" placeholder="Isi Kode Cabang/Proyek" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.branch_code ?? ""} invalid={validation.touched.branch_code && validation.errors.branch_code ? true : false} />
                          {validation.touched.branch_code && validation.errors.branch_code ? <FormFeedback type="invalid">{validation.errors.branch_code}</FormFeedback> : null}
                        </div>
                        {/* <div className="mb-1">
                          <Input name="isWarehouse" id="isWarehouse-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isWarehouse} /> &nbsp;
                          <Label htmlFor="isWarehouse-field" className="form-label">
                            is Warehouse ?
                          </Label>
                        </div>
                        <div className="mb-1">
                          <Input name="isSellingOffline" id="isSellingOffline-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isSellingOffline} /> &nbsp;
                          <Label htmlFor="isSellingOffline-field" className="form-label">
                            Selling Offline
                          </Label>
                        </div>
                        <div className="mb-3">
                          <Input name="isSellingOnline" id="isSellingOnline-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isSellingOnline} />
                          &nbsp;
                          <Label htmlFor="isSellingOnline-field" className="form-label">
                            Selling Online
                          </Label>
                        </div> */}
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="sbum">
                            Nilai SBUM
                          </label>
                          <Input
                            type="number"
                            className="form-control"
                            id="sbum"
                            placeholder="Isi nilai subsidi proyek"
                            name="sbum"
                            value={validation.values.sbum}
                            onBlur={validation.handleBlur}
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => {
                              validation.setFieldValue("sbum", e.target.value);
                            }}
                          />
                        </div>
                        {/* <div className="mb-3">
                          <Label htmlFor="attendance_distance-field" className="form-label">
                            {t("Attendance Distance")} <span className="text-danger">*</span>
                          </Label>
                          <Input name="attendance_distance" id="attendance_distance-field" className="form-control" placeholder="Enter Distance" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.attendance_distance ?? ""} invalid={validation.touched.attendance_distance && validation.errors.attendance_distance ? true : false} />
                          {validation.touched.attendance_distance && validation.errors.attendance_distance ? <FormFeedback type="invalid">{validation.errors.attendance_distance}</FormFeedback> : null}
                        </div> */}
                        {/* <div className='mb-3'>
                          <Label htmlFor='address-field' className='form-label'>
                            {t("Alamat")}
                          </Label>
                          <GooglePlacesAutocomplete
                            apiKey='AIzaSyD0auKcsMNas3qbqi-BgF_s3UxwtQNP74Q'
                            apiOptions={{
                              region: "IDN",
                            }}
                            autocompletionRequest={{
                              componentRestrictions: {
                                country: ["idn"],
                              },
                              types: ["route"],
                            }}
                            selectProps={{
                              name: "address",
                              value: undefined,
                              defaultValue: validation.values.address,
                              onChange: (value) => {
                                validation.setFieldValue("address", value);
                                setPlaceValue(value);
                              },
                            }}/>
                          {validation.touched.address &&
                            validation.errors.address ? (
                            <div className='invalid-feedback d-block'>
                              {validation.errors.address}
                            </div>
                          ) : null}
                        </div> */}
                        <div className="mb-3">
                          <Label htmlFor="zip-field" className="form-label">
                            {t("Kode Pos")}
                          </Label>
                          <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                          {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="street-field" className="form-label">
                            {t("Alamat")}
                          </Label>
                          <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat Proyek / Cabang" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street ?? ""} invalid={validation.touched.street && validation.errors.street ? true : false} />
                          {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 d-flex justify-content-between">
                          <Label htmlFor="taskFiles" className="form-label me-3">
                            Dokumen Proyek / Cabang
                          </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success"
                            onClick={() => {
                              setMediaType("files");
                              toggleMedia();
                            }}
                          >
                            <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                          </button>
                        </div>
                        {assetFiles.map((file, i) => {
                          if (file.isDeleted) {
                            return null;
                          } else {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="d-flex justify-content-between mb-3 align-items-center">
                                  <div
                                    onClick={() => {
                                      const typeFile = file.filename.split(".");
                                      if (typeFile[typeFile.length - 1] === "x-compressed") {
                                        window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                      } else if (typeFile[typeFile.length - 1] === "sheet") {
                                        window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                      } else if (typeFile[typeFile.length - 1] === "pdf") {
                                        window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                      } else {
                                        //
                                      }
                                    }}
                                  >
                                    {renderIcon(file.filename)}
                                    <div className="text-truncate">{file.originalname}</div>
                                  </div>
                                  <div>
                                    <Link
                                      to="#"
                                      className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                      onClick={(e) => {
                                        handleDeleteFile(file);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label htmlFor="latitude-field" className="form-label">
                            Latitude
                          </Label>
                          <Input name="latitude" id="latitude-field" className="form-control" placeholder="Isi Latitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.latitude ?? ""} invalid={validation.touched.latitude && validation.errors.latitude ? true : false} />
                          {validation.touched.latitude && validation.errors.latitude ? <FormFeedback type="invalid">{validation.errors.latitude}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="longitude-field" className="form-label">
                            Longitude
                          </Label>
                          <Input name="longitude" id="longitude-field" className="form-control" placeholder="Isi Longitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longitude ?? ""} invalid={validation.touched.longitude && validation.errors.longitude ? true : false} />
                          {validation.touched.longitude && validation.errors.longitude ? <FormFeedback type="invalid">{validation.errors.longitude}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="visibility" className="form-label">
                            Visibility
                          </Label>
                          <Select
                            name="visibility"
                            placeholder="Pilih Visibility"
                            value={validation.values.visibility}
                            onChange={(e) => {
                              validation.setFieldValue("visibility", e);
                            }}
                            options={statusVisibilityData}
                          ></Select>
                          {validation.touched.visibility && validation.errors.visibility && (
                            <small className="text-danger" type="invalid">
                              {validation.errors.visibility}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="active-status" className="form-label">
                            {t("Status")}
                          </Label>
                          <Select
                            name="status"
                            value={validation.values.status}
                            validate={{ required: { value: true } }}
                            placeholder="Pilih Status"
                            onChange={(e) => {
                              validation.setFieldValue("status", e);
                            }}
                            options={statusActiveData}
                            invalid={validation.touched.status && validation.errors.status ? true : false}
                          ></Select>
                          {validation.touched.status && validation.errors.status ? (
                            <p className="invalid-feedback d-block" type="invalid">
                              {validation.errors.status}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="des-field" className="form-label">
                            {t("Keterangan")}
                          </Label>
                          <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="svg_siteplan-field" className="form-label">
                            {t("SVG Siteplan Penjualan")}
                          </Label>
                          <Input name="svg_siteplan" id="svg_siteplan-field" className="form-control" placeholder="Isi Siteplan" type="textarea" rows={7} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.svg_siteplan ?? ""} />
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="svg_siteplan_project-field" className="form-label">
                            {t("SVG Siteplan Proyek")}
                          </Label>
                          <Input name="svg_siteplan_project" id="svg_siteplan_project-field" className="form-control" placeholder="Isi Siteplan" type="textarea" rows={7} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.svg_siteplan_project ?? ""} />
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="svg_rincik-field" className="form-label">
                            {t("SVG Rincik")}
                          </Label>
                          <Input name="svg_rincik" id="svg_rincik-field" className="form-control" placeholder="Isi Rincik" type="textarea" rows={7} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.svg_rincik ?? ""} />
                        </div>
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModal(false);
                          validation.resetForm();
                          validation.setErrors({});
                          setCompanyList([]);
                        }}
                      >
                        {t("Batal")}
                      </button>
                      <button
                        onClick={() => {
                          validation.handleSubmit();
                        }}
                        type="submit"
                        className="btn btn-success"
                      >
                        <span className="d-flex align-items-center">
                          <span className="flex-grow-1 me-2">{t("Simpan")}</span>
                          {loading && (
                            <Spinner size="sm" className="flex-shrink-0" role="status">
                              Loading...
                            </Spinner>
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <CardBody className="text-center">
                <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                  <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={locationCord}>
                    <Popup>{info.branch_branch && info.branch_branch.name ? info.branch_branch.name : "-"}</Popup>
                  </Marker>
                </MapContainer>
              </CardBody>
              <div className="card-body">
                <h6 className="text-muted text-uppercase fw-semibold mb-2">information</h6>
                <p className="text-muted mb-4">{info.description ? info.description : "-"} </p>
                <div className="table-card p-2">
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Siteplan:
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div className="mb-3 p-3">
                    {/* <TransformWrapper>
                      {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                        <>
                          <Controls />
                          <TransformComponent>{info.svg_siteplan ? (parse(info.svg_siteplan)) : "Siteplan belum di upload"}</TransformComponent>
                        </>
                      )}
                    </TransformWrapper> */}
                    {info.svg_siteplan ? parse(info.svg_siteplan) : "Siteplan belum di upload"}
                    <table className="table align-middle table-nowrap mb-3">
                      <thead className="table-active">
                        <tr>
                          <th scope="col" className="p-2 pt-3 pb-3">
                            Siteplan Proyek:
                          </th>
                        </tr>
                      </thead>
                    </table>
                    <div className="mb-3 p-3"></div>
                    {info.svg_siteplan_project ? parse(info.svg_siteplan_project) : "Siteplan proyek belum di upload"}
                    <table className="table align-middle table-nowrap mb-3">
                      <thead className="table-active">
                        <tr>
                          <th scope="col" className="p-2 pt-3 pb-3">
                            Rincik:
                          </th>
                        </tr>
                      </thead>
                    </table>
                    <div className="mb-3 p-3"></div>
                    {info.svg_rincik ? parse(info.svg_rincik) : "Rincik belum di upload"}
                  </div>

                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen Proyek / Cabang:
                        </th>
                      </tr>
                    </thead>
                    <tbody id="file-list">
                      {(info.branch_file || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "file"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <input className="form-control filelist-id" type="hidden" value="1" id="filelist-1" />
                              <div className="d-flex align-files-center">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 filelist-name">{file.originalname}</div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <table className="table table-responsive table-striped">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" colSpan={2} className="p-2 pt-3 pb-3">
                          Informasi Lainnya:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2">Keterangan</td>
                        <td className="p-2">{info.description ? info.description : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info.branch_company && info.branch_company.name ? info.branch_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Lokasi</td>
                        <td className="p-2">
                          {info.latitude}, {info.longitude}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.branch_createdby && info.branch_createdby.name ? info.branch_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.branch_updatedby && info.branch_updatedby.name ? info.branch_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
      </Container>
    </div>
  );
};

Branch.propTypes = {
  branch: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Branch));
